import { useWorkspace } from '../context/useWorkspace'

export function useWorkspaceAiSuggestions(): boolean {
  const { workspaces, activeWorkspaceId } = useWorkspace()
  const activeWorkspace = workspaces.find((w) => w.id === activeWorkspaceId)
  return activeWorkspace?.workspacePreferences?.aiSuggestionsEnabled !== false
}
